import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import { ModalOverlayPositioning } from '../../../styled-components//NotificationModalStyledComponents';
import { BackdropOverlay } from '../../../styled-components/GlobalStyledComponents';

const BackDropComponent = (props: { onHide: () => void; className: string; zIndex?: number }) => {
  //Teleport this to root-backdrop
  return (
    <BackdropOverlay
      className={`backdrop`}
      onClick={props.onHide}
      zIndex={`${props.zIndex} !important` || '5'}
    />
  );
};

const ModalOverlay = (props: {
  className: string;
  children: React.ReactNode;
  extraStyling?: string;
  onHide: () => void;
}) => {
  return (
    <div className={props.className}>
      <div className="modal__content " onClick={props.onHide}>
        {props.children}
      </div>
    </div>
  );
};

const Modal = (props: {
  onHide: () => void;
  className?: string;
  children: React.ReactNode;
  extraStyling?: string;
  top?: number;
  right?: number;
  hideBackdrop?: boolean;
  zIndex?: number;
}) => {
  return (
    <Fragment>
      {!props.hideBackdrop &&
        ReactDOM.createPortal(
          <BackDropComponent
            className={props.className || ''}
            onHide={props.onHide}
            zIndex={props.zIndex}
          />,
          document.getElementById('root-popup')!
        )}
      {ReactDOM.createPortal(
        <ModalOverlay
          className={props.className || ''}
          extraStyling={props.extraStyling || ''}
          onHide={props.onHide}
        >
          {props.children}
        </ModalOverlay>,
        document.getElementById('root-popup')!
      )}
    </Fragment>
  );
};

export default Modal;
